export default __webpack_public_path__ + "static/media/seelater-icon-black.36a36d03.svg";